/**
 * VERSIONS — Arquivo Único de Versionamento
 *
 * Workflow: alterar a versão aqui, atualizar SITE_MAP.md e então build, commit,
 * push e deploy.
 */

// ── Site ──────────────────────────────────────────
export const SITE_VERSION = '10.468.28'

// ── Games ─────────────────────────────────────────
export const PP_VERSION        = '2.3.2'
export const LDI_VERSION       = '3.32.0'
export const JACK_VERSION      = '5.3.3'
export const GANGUES_VERSION   = '3.116.0'

export const TAMA_VERSION      = '3.4.2'
export const DUELO_VERSION     = '2.8.1'
export const MINIGAMES_VERSION = '4.3.7'
export const TS_VERSION        = '6.0.6'
export const TM_VERSION        = '6.0.4'
export const TATICS_VERSION    = '7.5.1'
export const SRGRM_VERSION     = '3.5.0'
export const ARENATESTBED_VERSION = '6.26.0'
export const KP_VERSION        = '1.4.2'
export const SLIDING_VERSION   = '1.4.4'
export const CODIGO_VERSION    = '1.3.3'
export const MAZE_VERSION      = '1.1.4'
export const GLITCH_VERSION    = '1.1.7'
export const BULLETHELL_VERSION = '1.1.3'
export const STABILIZER_VERSION = '1.1.2'

// ── Logs (executam na inicialização do site) ──────
console.log(`[SITE] versão carregada: ${SITE_VERSION}`)
console.log(`[PP] versão carregada: ${PP_VERSION}`)
console.log(`[LDI] versão carregada: ${LDI_VERSION}`)
console.log(`[JACK] versão carregada: ${JACK_VERSION}`)
console.log(`[GANGUES] versão carregada: ${GANGUES_VERSION}`)
console.log(`[TATICS] versão carregada: ${TATICS_VERSION}`)
console.log(`[SRGRM] versão carregada: ${SRGRM_VERSION}`)
console.log(`[LDI ARENA] versão carregada: ${ARENATESTBED_VERSION}`)
console.log(`[KP] versão carregada: ${KP_VERSION}`)
console.log(`[TAMA] versão carregada: ${TAMA_VERSION}`)
console.log(`[DUELO] versão carregada: ${DUELO_VERSION}`)
console.log(`[MINIGAMES] versão carregada: ${MINIGAMES_VERSION}`)
console.log(`[SLIDING] versão carregada: ${SLIDING_VERSION}`)
console.log(`[CODIGO] versão carregada: ${CODIGO_VERSION}`)
console.log(`[MAZE] versão carregada: ${MAZE_VERSION}`)
console.log(`[GLITCH] versão carregada: ${GLITCH_VERSION}`)
console.log(`[BULLETHELL] versão carregada: ${BULLETHELL_VERSION}`)
console.log(`[STABILIZER] versão carregada: ${STABILIZER_VERSION}`)
console.log(`[TS] versão carregada: ${TS_VERSION}`)
console.log(`[TM] versão carregada: ${TM_VERSION}`)
